import { getUserRegion } from './cookie'

const brand = getUserRegion()
const isTW = brand === 'TW'

export const wordPressHost = isTW ? `${window.location.origin}` : `${window.location.origin}/${brand.toLowerCase()}`

export const getCurrentPageUrl = () => `${window.location.origin}${window.location.pathname}`
